import React from 'react'
import Modal from 'react-bootstrap/Modal'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

// images
import CloseImg from '../../assets/image/close/ic-close-b.svg'

const DeleteModal = ({ show, handleClose, message, buttons, handleSubmit }) => {
  return (
    <Modal
      dialogClassName="custom-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
    >
      <Wrapper>
        <HeaderWrapper>
          {/* <img src={CloseImg} onClick={handleClose} /> */}
        </HeaderWrapper>

        <ContentsWrapper>{message}</ContentsWrapper>

        <ButtonWrapper>
          {buttons.map((txt, idx) => (
            <Btn
              key={idx}
              isLast={idx === 1}
              onClick={() => {
                if (idx === 0) {
                  handleClose()
                } else {
                  handleSubmit()
                }
              }}
            >
              {txt}
            </Btn>
          ))}
        </ButtonWrapper>
      </Wrapper>
    </Modal>
  )
}

export default DeleteModal

const Wrapper = styled.div`
  padding: 20px;
  height: 190px;
  display: flex;
  flex-direction: column;
`

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
`

const ContentsWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const Btn = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 135px;
  height: 50px;
  border: ${(props) => !props.isLast && `1px solid ${colors.G3}`};
  background-color: ${(props) => props.isLast && `${colors.mainG}`};
  color: ${(props) => (props.isLast ? `${colors.W1}` : `${colors.BK}`)};
  border-radius: 8px;
`
